import { InitiativeStatusType } from 'types/entities/initiative';
import { styled } from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizes.sm};
`;

export const Card = styled.div<{ $rowClickable?: boolean }>`
  cursor: ${({ $rowClickable }) => ($rowClickable ? 'pointer' : 'default')};
  background-color: ${({ theme }) => theme.colors.neutral50};
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  padding: ${({ theme }) => theme.sizes.md} ${({ theme }) => theme.sizes.lg};
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.sizes.md} ${({ theme }) => theme.sizes.lg};

  &:hover {
    background-color: ${({ theme, $rowClickable }) =>
      $rowClickable ? theme.colors.neutral100 : theme.colors.neutral50};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: column;
    padding: ${({ theme }) => theme.sizes.md};
    gap: ${({ theme }) => theme.sizes.sm};
  }
`;

export const CardField = styled.div<{ $width?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizes.xs};
  width: ${({ $width }) => ($width ? `${$width}px` : '250px')};
  min-width: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
  }
`;

export const CardFieldLabel = styled.span`
  font-size: ${({ theme }) => theme.sizes.sm};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral800};
  white-space: nowrap;
`;

export const CardFieldValue = styled.span`
  font-size: ${({ theme }) => theme.sizes.sm};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.neutral800};
`;

export const StatusBadge = styled.span<{ $variant?: InitiativeStatusType }>`
  display: inline-block;
  padding: ${({ theme }) => theme.sizes.xs} ${({ theme }) => theme.sizes.sm};
  border-radius: 999px;
  font-size: ${({ theme }) => theme.sizes['2xs']};
  font-weight: 600;
  width: fit-content;
  background-color: ${({ theme, $variant }) =>
    $variant === 'ACTIVE' ? theme.colors.green100 : theme.colors.red100};
  color: ${({ theme, $variant }) =>
    $variant === 'ACTIVE' ? theme.colors.green700 : theme.colors.red700};
`;

export const Actions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizes.xs};
  // flex-direction: column;
`;

export const Action = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.sizes.xs};
  background-color: ${({ theme }) => theme.colors.neutral50};
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.neutral200};
  padding: ${({ theme }) => theme.sizes.xs} ${({ theme }) => theme.sizes.sm};
  width: 60px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutral100};
  }
`;

export const PaginationBar = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.sizes.md};
  margin-top: ${({ theme }) => theme.sizes.md};
  padding-top: ${({ theme }) => theme.sizes.md};
  border-top: 1px solid ${({ theme }) => theme.colors.neutral200};
`;

export const PaginationInfo = styled.span`
  font-size: ${({ theme }) => theme.sizes.sm};
  color: ${({ theme }) => theme.colors.neutral800};
`;

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizes.sm};
`;

export const PaginationButton = styled.button<{ $disabled?: boolean }>`
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  font-size: ${({ theme }) => theme.sizes.sm};
  font-weight: 600;
  color: ${({ theme, $disabled }) =>
    $disabled ? theme.colors.neutral400 : theme.colors.neutral800};
  background-color: ${({ theme }) => theme.colors.neutral50};
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.neutral200};
  padding: ${({ theme }) => theme.sizes.xs} ${({ theme }) => theme.sizes.md};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.neutral100};
  }
`;
